import React from "react";
import { Command, Keyboard } from "lucide-react";

const SECTIONS = [
  {
    title: "Global",
    items: [
      { keys: ["⌘", "K"], desc: "Open Spotlight / Command Palette" },
      { keys: ["⌘", "/"], desc: "Type / inside Spotlight for slash commands" },
      { keys: ["Esc"], desc: "Close Spotlight / dialog" },
      { keys: ["⌘", "Shift", "V"], desc: "Toggle global voice commands (TopBar mic)" },
    ],
  },
  {
    title: "Windows",
    items: [
      { keys: ["Drag header"], desc: "Move window" },
      { keys: ["Double-click header"], desc: "Maximize / restore" },
      { keys: ["Drag corner"], desc: "Resize" },
    ],
  },
  {
    title: "Apps",
    items: [
      { keys: ["⌘", "N"], desc: "New chat in HEXA Chat" },
      { keys: ["⌘", "Enter"], desc: "Send message in Chat / Mail compose" },
      { keys: ["↑ / ↓"], desc: "Terminal history navigation" },
      { keys: ["⌫"], desc: "Backspace in Calculator" },
      { keys: ["Enter"], desc: "= in Calculator" },
    ],
  },
];

export default function Shortcuts() {
  const renderKey = (k) => (
    <kbd className="px-1.5 py-0.5 rounded bg-white/10 border border-white/15 text-[10px] mono">{k}</kbd>
  );
  return (
    <div className="h-full overflow-y-auto p-6" data-testid="app-shortcuts">
      <div className="flex items-center gap-2 mb-5">
        <Keyboard size={18} color="#ff7a2e" />
        <div>
          <div className="text-base font-medium tracking-tight">Keyboard Shortcuts</div>
          <div className="text-[11px] text-white/40">Speed-run HEXA OS with the keyboard.</div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {SECTIONS.map(sec => (
          <div key={sec.title} className="rounded-lg border border-white/10 bg-white/3 p-3">
            <div className="text-[10px] uppercase tracking-widest text-white/40 mb-2">{sec.title}</div>
            <div className="space-y-1.5">
              {sec.items.map((it, i) => (
                <div key={i} className="flex items-center justify-between text-xs">
                  <span className="text-white/80">{it.desc}</span>
                  <div className="flex items-center gap-1">
                    {it.keys.map((k, j) => (
                      <React.Fragment key={j}>
                        {renderKey(k)}
                        {j < it.keys.length - 1 && <span className="text-white/30">+</span>}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 p-3 rounded-lg border border-white/10 bg-white/3 flex items-start gap-2 text-xs text-white/70">
        <Command size={12} className="text-[#ff7a2e] mt-0.5" />
        <span>Tip: open the Spotlight (⌘K) and type <span className="mono text-[#ff7a2e]">/</span> to see all slash commands — open apps, compose mail, schedule meetings, run scans, generate images, do math, and more.</span>
      </div>
    </div>
  );
}
